import { action } from 'satcheljs';
import datapoints from '../../../datapoints';
/**
 * Favorites have been loaded in store
 */
export default action('outlookFavoritePersonasLoaded', function (personas) { return ({
    personas: personas,
    datapointConfig: datapoints.OutlookFavoritePersonasLoaded.datapoint,
}); });
//# sourceMappingURL=outlookFavoritePersonasLoaded.js.map